// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.research_vehicle h5[data-v-3221e1c0] {
  font-size: 1vw;
}
.tab_models[data-v-3221e1c0] {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}
.each_tab_model[data-v-3221e1c0] {
  padding: 15px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px 0px;
  text-align: center;
}
.each_tab_model h4[data-v-3221e1c0] {
  font-size: 0.8vw;
  font-weight: bold;
}
.each_tab_model a[data-v-3221e1c0] {
  text-decoration: none;
}
.chat_btn_outline[data-v-3221e1c0] {
  background: #fff;
  border: 0;
  border-radius: 5px;
  padding: 8px;
  text-transform: uppercase;
  font-size: 0.6vw;
  font-weight: 400;
  display: block;
  width: 100%;
  cursor: pointer;
  outline: none;
}
.each_tab_model img[data-v-3221e1c0] {
  height: 9vh;
  display: block;
  margin: 0 auto;
}
.tab_btn.selected_tab[data-v-3221e1c0] {
  border-bottom: 3px solid;
  opacity: 1;
  font-weight: 600;
}
.tab_btn[data-v-3221e1c0] {
  cursor: pointer;
  font-size: 0.8vw;
  opacity: 0.6;
  text-decoration: none;
}
.animated_bottom[data-v-3221e1c0] {
  animation: animated_bottom-3221e1c0 2s;
  transition: 0.5s;
}
@keyframes animated_bottom-3221e1c0 {
0% {
    transform: translateY(30px);
}
100% {
    transform: translateY(0px);
}
}
.slide-up-enter-active[data-v-3221e1c0] {
  animation: animated_bottom-3221e1c0 1s;
  transition: 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmSlideOutResearchModels/TvmSlideOutResearchModels.vue","webpack://./TvmSlideOutResearchModels.vue"],"names":[],"mappings":"AACA;EAEI,cAAA;ACDJ;ADKA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;ACHF;ADMA;EACE,aAAA;EACA,mBAAA;EACA,+CAAA;EACA,kBAAA;ACJF;ADAA;EAOI,gBAAA;EACA,iBAAA;ACJJ;ADJA;EAYI,qBAAA;ACLJ;ADSA;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;ACPF;ADUA;EACE,WAAA;EACA,cAAA;EACA,cAAA;ACRF;ADWA;EACE,wBAAA;EACA,UAAA;EACA,gBAAA;ACTF;ADYA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;ACVF;ADaA;EACE,sCAAA;EACA,gBAAA;ACXF;ADcA;AACE;IACE,2BAAA;ACZF;ADeA;IACE,0BAAA;ACbF;AACF;ADgBA;EACE,sCAAA;EACA,gBAAA;ACdF","sourcesContent":["\n.research_vehicle {\n  h5 {\n    font-size: 1vw;\n  }\n}\n\n.tab_models {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 15px;\n}\n\n.each_tab_model {\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.10) 0px 5px 15px 0px;\n  text-align: center;\n\n  h4 {\n    font-size: 0.8vw;\n    font-weight: bold;\n  }\n\n  a {\n    text-decoration: none;\n  }\n}\n\n.chat_btn_outline {\n  background: #fff;\n  border: 0;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n  font-size: 0.6vw;\n  font-weight: 400;\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  outline: none;\n}\n\n.each_tab_model img {\n  height: 9vh;\n  display: block;\n  margin: 0 auto;\n}\n\n.tab_btn.selected_tab {\n  border-bottom: 3px solid;\n  opacity: 1;\n  font-weight: 600;\n}\n\n.tab_btn {\n  cursor: pointer;\n  font-size: 0.8vw;\n  opacity: 0.6;\n  text-decoration: none;\n}\n\n.animated_bottom {\n  animation: animated_bottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animated_bottom {\n  0% {\n    transform: translateY(30px);\n  }\n\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n.slide-up-enter-active {\n  animation: animated_bottom 1s;\n  transition: 0.5s;\n}\n",".research_vehicle h5 {\n  font-size: 1vw;\n}\n.tab_models {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 15px;\n}\n.each_tab_model {\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 15px 0px;\n  text-align: center;\n}\n.each_tab_model h4 {\n  font-size: 0.8vw;\n  font-weight: bold;\n}\n.each_tab_model a {\n  text-decoration: none;\n}\n.chat_btn_outline {\n  background: #fff;\n  border: 0;\n  border-radius: 5px;\n  padding: 8px;\n  text-transform: uppercase;\n  font-size: 0.6vw;\n  font-weight: 400;\n  display: block;\n  width: 100%;\n  cursor: pointer;\n  outline: none;\n}\n.each_tab_model img {\n  height: 9vh;\n  display: block;\n  margin: 0 auto;\n}\n.tab_btn.selected_tab {\n  border-bottom: 3px solid;\n  opacity: 1;\n  font-weight: 600;\n}\n.tab_btn {\n  cursor: pointer;\n  font-size: 0.8vw;\n  opacity: 0.6;\n  text-decoration: none;\n}\n.animated_bottom {\n  animation: animated_bottom 2s;\n  transition: 0.5s;\n}\n@keyframes animated_bottom {\n  0% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.slide-up-enter-active {\n  animation: animated_bottom 1s;\n  transition: 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
